<template>
  <section :id="`uuid-${$attrs.uuid}`" class="section card-big">
    <div class="card-big-container section__container">
      <div class="section__wrapper">
        <picture class="card-big__picture">
          <div class="card-big__info-container-flex">
            <div class="card-big__info-container">
              <span v-if="cardBigEventCategory" class="card-big__event-category" >{{cardBigEventCategory.title}}</span>
              <h4 class="card-big__title" :class="[blackTheme, {'event': cardBigEventCategory}]">{{cardTitle}}</h4>
              <div class="card-big__paragraph" :class="blackTheme" v-html='cardParagraph'></div>
              <div class="card-big__cta-links">
                <template v-for="ctaObj in ctaLinks">
                  <advanced-button-wrapper
                      class="card-big-cta-link"
                      :key="ctaObj.uuid"
                      :cta-obj="ctaObj"
                      color="primary"
                      styleType="text"
                      size="medium"
                      :analyticsData="analyticsData(ctaObj)" />
                </template>
              </div>
            </div>
          </div>
          <source
              media="(min-width:0) and (max-width:640px)"
              :srcset="cardBigImgMobile | mgnlMedia('url')"
              v-if="cardBigImgMobile"
          />
          <source
              media="(min-width:0) and (max-width:640px)"
              :srcset="cardBigImgDesktop | mgnlMedia('url')"
              v-else-if="!cardBigImgMobile"
          />
          <source
              v-else
              media="(min-width:641px)"
              :srcset="cardBigImgDesktop | mgnlMedia('url')"
          />
          <pg-image
              :lazy-src="isMobileImage | mgnlMedia('url')"
              :alt="imageAlt"
              :width="540"
              :height="720"
          />
          <div v-if="!blackTheme" class="card-big__gradient" :class="{'disabled' : disableGradient }"></div>
        </picture>
      </div>
    </div>
  </section>
</template>

<script>
import PgImage from "../Image/Image.vue";
import advancedButtonWrapper from "../Advanced-Button-Wrapper/Advanced-Button-Wrapper";
import {mgnlComponentMixin} from "@wl-vue-mixins/mixins";

export default {
  mixins: [mgnlComponentMixin], // !!! all the mgnl components must be configured with mgnlComponentMixin !!!
  name: "CardBig",

  components: {
    advancedButtonWrapper,
    PgImage
  },

  props: {
    disableGradient : {
      type: Boolean
    },
    ctaLinks: {
      type: Array,
      default: () => []
    },
    cardBigEventCategory: {
      type: Object,
      default: () => {}
    },
    cardTitle: {
      type: String,
      default: ''
    },
    cardParagraph: {
      type: String,
      default: ''
    },
    cardBigBlackTheme: {
      type: Boolean,
      default: false
    },
    cardBigImgDesktop: {
      type: Object,
      default: () => {}
    },
    cardBigImgMobile: {
      type: Object,
      default: () => {}
    },
  },

  computed: {
    isMobile() {
      return window.matchMedia('only screen and (max-width: 640px)').matches;
    },
    isMobileImage() {
      return this.isMobile && this.cardBigImgMobile ? this.cardBigImgMobile : this.cardBigImgDesktop;
    },
    imageAlt() {
      return this.isMobile && this.cardBigImgMobile ? this.cardBigImgMobile.title : this.cardBigImgDesktop.title;
    },
    blackTheme() {
      return this.cardBigBlackTheme ? "text-black" : "";
    }
  },

  methods: {
    analyticsData(el) {
      return {
        evCategory: 'card_big',
        evAction: el.document?.url || el.link?.url || el.trackingLabel,
        evLabel: `${el.campaignId || 'No Campaign'} | ${this.common.actpageFullUrl}`
      }
    }
  }
}

</script>